import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecarrentalsserviceinpune() {



  const cardData =
  {
    keyword: 'Corporate Car Rentals Services in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Car Rentals Services in Pune',
    headingDescription: ' Pune Corporate Cars India Private Limited offers top-tier Corporate Car Rentals Services in Pune, ensuring businesses enjoy smooth, professional, and luxurious travel at all times. Our service includes a wide range of premium sedans, SUVs, and executive vehicles designed for corporate meetings, employee mobility, airport transfers, and VIP transportation. With experienced chauffeurs, flexible rental packages, and punctual service, we provide a hassle-free corporate travel experience that enhances comfort and productivity. Whether you need daily office cabs, dedicated cars for management, or chauffeur-driven rentals for clients and guests, Pune Corporate Cars India Private Limited delivers dependable, safe, and high-quality corporate car rental services customized for your business needs.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



  "services": [
  {
    "name": "Corporate Car Booking Pune",
    "description": "Corporate Car Booking Pune offers seamless, quick, and professional car reservation services for businesses of all sizes. Whether it's daily office travel, client meetings, airport transfers, or executive mobility, our booking system ensures fast confirmation and reliable service. All vehicles are well-maintained, fully sanitized, and driven by trained chauffeurs. Companies benefit from structured billing, priority support, and flexible booking slots. Corporate Car Booking Pune guarantees convenience, punctuality, and a smooth travel experience every time."
  },
  {
    "name": "Pune Business Car Hire",
    "description": "Pune Business Car Hire provides premium, comfortable, and efficient car rental solutions tailored for business professionals. Our fleet includes sedans, SUVs, and executive cars suitable for meetings, site visits, conferences, and official events. Each car is driven by a trained chauffeur ensuring safe, timely, and stress-free travel. Businesses can opt for hourly, daily, or monthly packages with transparent pricing. Pune Business Car Hire delivers reliability and professionalism to support your daily corporate travel requirements."
  },
  {
    "name": "Staff Car Rental Service Pune",
    "description": "Staff Car Rental Service Pune ensures safe, punctual, and affordable transportation for employees across all office locations in the city. Designed for daily pickup and drop needs, the service includes dedicated vehicles, verified chauffeurs, and optimized routes. Our cars come with clean interiors, AC, and real-time tracking. Ideal for companies with shift-based operations, large teams, or fieldwork requirements. Staff Car Rental Service Pune improves workforce mobility, productivity, and satisfaction through dependable daily travel."
  },
  {
    "name": "Chauffeur Car Services Pune",
    "description": "Chauffeur Car Services Pune offers luxury, convenience, and professional chauffeur-driven travel for corporate executives. Our chauffeurs are trained in corporate etiquette, safe driving, and punctuality. Vehicles include sedans, SUVs, and premium models equipped with comfortable interiors and smooth suspension. Ideal for airport transfers, VIP guests, meetings, and corporate events. The service offers flexible rental durations and hassle-free travel with complete privacy and comfort. Chauffeur Car Services Pune ensures a world-class executive travel experience."
  },
  {
    "name": "Corporate Hatchback Rental Pune",
    "description": "Corporate Hatchback Rental Pune provides budget-friendly yet efficient hatchback cars perfect for daily office commutes, staff movement, and local corporate travel. Hatchbacks offer excellent fuel efficiency, easy city navigation, and comfortable seating for short to medium-distance travel. Each vehicle is routinely serviced, fully sanitized, and driven by trained drivers. Companies benefit from economical monthly packages and reliable service. Corporate Hatchback Rental Pune is ideal for startups, small teams, and everyday business mobility needs."
  },
  {
    "name": "Corporate Sedan Hire Pune",
    "description": "Corporate Sedan Hire Pune offers stylish, spacious, and comfortable sedans including Dzire, Etios, Honda City, and Verna. These cars are perfect for executive travel, business meetings, inter-office visits, and airport transfers. Sedans ensure smooth rides, superior comfort, and a premium feel suitable for professional use. With dedicated chauffeurs, flexible plans, and well-maintained vehicles, Corporate Sedan Hire Pune delivers an exceptional travel experience for your organization."
  },
  {
    "name": "Executive Car Rentals Pune",
    "description": "Executive Car Rentals Pune provides top-tier, luxury vehicles tailored for high-ranking executives, VIP clients, and corporate leaders. Our fleet includes premium sedans, high-comfort SUVs, and silent-cabin executive cars. Chauffeurs are handpicked and trained in etiquette, confidentiality, and safe driving. Ideal for high-value meetings, airport transfers, and corporate events. Executive Car Rentals Pune guarantees elegance, professionalism, and complete comfort throughout your journey."
  },
  {
    "name": "Pune Corporate Fleet Solutions",
    "description": "Pune Corporate Fleet Solutions offers businesses a complete fleet management system with sedans, SUVs, hatchbacks, and premium cars assigned on a long-term basis. We handle driver management, vehicle maintenance, insurance, and replacements. Ideal for IT companies, business parks, manufacturing units, and enterprises needing continuous staff and executive mobility. With centralized billing, dedicated support, and scalable plans, Pune Corporate Fleet Solutions ensures smooth and cost-efficient transportation operations."
  },
  {
    "name": "Best Corporate Car Services Pune",
    "description": "Best Corporate Car Services Pune delivers high-quality, punctual, and professional travel solutions for businesses of all sizes. Our fleet includes clean, comfortable, and well-maintained vehicles suitable for executives, staff, and clients. We offer daily rental, monthly plans, airport drops, and outstation travel options. Known for reliability, excellent service, and trained chauffeurs, Best Corporate Car Services Pune helps businesses maintain smooth and efficient travel operations."
  },
  {
    "name": "Affordable Car Rentals Pune",
    "description": "Affordable Car Rentals Pune offers budget-friendly travel solutions without compromising on quality or safety. Our fleet includes hatchbacks, sedans, and SUVs available at economical rates for corporate travel. Vehicles are regularly serviced, sanitized, and driven by experienced drivers. Companies benefit from transparent pricing, daily and monthly rental plans, and quick booking options. Affordable Car Rentals Pune is the perfect choice for cost-conscious organizations looking for dependable mobility."
  },
  {
    "name": "Corporate Outstation Car Hire Pune",
    "description": "Corporate Outstation Car Hire Pune provides reliable and comfortable outstation travel solutions for meetings, conferences, corporate tours, and business trips. Our outstation fleet includes spacious sedans and SUVs with strong AC, plush seating, and smooth suspension. Chauffeurs are trained for long-distance routes, ensuring safe and hassle-free travel. Companies can choose from one-way, round-trip, or multi-day packages. Corporate Outstation Car Hire Pune ensures a smooth, timely, and premium travel experience across major cities."
  },
  {
    "name": "Office Pickup Drop Car Hire Pune",
    "description": "Office Pickup Drop Car Hire Pune offers daily pickup and drop services designed for employees and corporate staff. We provide route planning, dedicated vehicles, verified drivers, and predictable monthly billing. Cars are equipped with AC, comfortable seating, and real-time tracking for enhanced safety. This service helps companies maintain punctuality, reduce employee stress, and improve overall productivity. Office Pickup Drop Car Hire Pune is suitable for companies operating multiple shifts or remote office locations."
  },
  {
    "name": "Company Car Rental Provider Pune",
    "description": "Company Car Rental Provider Pune delivers end-to-end corporate rental solutions with high-quality vehicles and professional drivers. We support daily travel, field operations, executive mobility, and staff transport. Companies can choose from hatchbacks, sedans, premium cars, and SUVs based on their needs. With strict maintenance routines, clean vehicles, and flexible rental plans, Company Car Rental Provider Pune ensures consistent, safe, and efficient corporate travel services."
  },
  {
    "name": "Employee Transportation Cars Pune",
    "description": "Employee Transportation Cars Pune offers safe, punctual, and organized mobility solutions for employees across Pune. Our vehicles are equipped with comfortable seating, AC, and GPS tracking for secure travel. We handle multi-route operations, shift timings, and custom schedules based on business needs. Perfect for IT companies, industrial units, corporate offices, and business parks. Employee Transportation Cars Pune enhances workforce mobility, reduces delays, and ensures smooth daily travel."
  },
  {
    "name": "Pune Airport Car Rental Corporate",
    "description": "Pune Airport Car Rental Corporate provides fast, professional, and on-time airport transfer services for executives and business travellers. Our chauffeurs track flight schedules, ensuring timely pickups and drop-offs. Vehicles include sedans, SUVs, and premium models with spacious cabins and smooth ride quality. Ideal for welcoming VIP guests, transporting employees, or managing business trips. Pune Airport Car Rental Corporate guarantees stress-free, reliable, and premium airport travel experiences."
  }
],
"tableData": [
  ["Corporate Car Booking Pune", "Pune Business Car Hire"],
  ["Staff Car Rental Service Pune", "Chauffeur Car Services Pune"],
  ["Corporate Hatchback Rental Pune", "Corporate Sedan Hire Pune"],
  ["Executive Car Rentals Pune", "Pune Corporate Fleet Solutions"],
  ["Best Corporate Car Services Pune", "Affordable Car Rentals Pune"],
  ["Corporate Outstation Car Hire Pune", "Office Pickup Drop Car Hire Pune"],
  ["Company Car Rental Provider Pune", "Employee Transportation Cars Pune"],
  ["Pune Airport Car Rental Corporate", ""]
],








"whychoose": [
  {
    "WhyChooseheading": "Corporate Car Rentals Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides professional and reliable corporate car rental services in Pune, perfect for daily business commutes and executive travel."
  },
  {
    "WhyChooseheading": "Wide Range of Corporate Vehicles",
    "WhyChoosedescription": "Select from a premium fleet of sedans, SUVs, and executive cars designed to meet the comfort and style requirements of corporate clients."
  },
  {
    "WhyChooseheading": "Clean, Safe & Well-Maintained Cars",
    "WhyChoosedescription": "All vehicles undergo routine servicing and thorough sanitization, ensuring a safe and pleasant travel experience."
  },
  {
    "WhyChooseheading": "Transparent Rental Pricing",
    "WhyChoosedescription": "Benefit from clear and competitive pricing with no hidden charges, ideal for short-term and long-term corporate rental needs."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, weekly, or monthly car rental packages tailored for corporate use."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our trained and experienced drivers ensure punctual, smooth, and stress-free travel for employees and executives."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, schedule changes, and special travel requests."
  },
  {
    "WhyChooseheading": "Quick and Seamless Booking",
    "WhyChoosedescription": "Book your corporate car rental easily online or by phone, with fast confirmations and reliable service."
  }
]



















  }

 const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate car rental services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and premium corporate car rental services for business meetings, official travel, and employee transportation across Pune.',
  },
  {
    question: 'How can I book corporate car rental services with Pune Corporate Cars India Private Limited?',
    answer: 'You can book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate car rentals in Pune?',
    answer: 'We offer a wide fleet including hatchbacks, sedans, SUVs, and luxury cars for various corporate travel needs.',
  },
  {
    question: 'Are drivers included with the corporate car rental service?',
    answer: 'Yes, all our corporate rentals come with trained, professional, and courteous drivers for a seamless experience.',
  },
  {
    question: 'Do you offer flexible corporate rental plans such as daily, weekly, or monthly packages?',
    answer: 'Absolutely. Pune Corporate Cars India Private Limited provides flexible rental plans based on daily, weekly, and monthly requirements.',
  },
  {
    question: 'Are corporate car rental services available 24×7 in Pune?',
    answer: 'Yes, we offer round-the-clock availability to support all your corporate travel schedules.',
  },
  {
    question: 'What safety measures are followed for corporate car rentals?',
    answer: 'All vehicles are sanitized before each trip and drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'What payment methods do you accept for corporate car rental services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate invoicing.',
  },
  {
    question: 'Is customer support available during the corporate rental service period?',
    answer: 'Yes, our 24×7 customer support team is always available to assist you during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Akash Deshmukh',
    feedback: 'Excellent corporate car rental service! The vehicle was clean, comfortable, and the driver was extremely professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Prachi Kulkarni',
    feedback: 'Very reliable service for our corporate travel needs. Pune Corporate Cars India Private Limited never disappoints. Highly recommended!',
    rating: 5,
  },
];









































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rentals Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-car-rentals-services-pune.jpg", // replace with actual image URL
  "description": "Reliable corporate car rental services in Pune offering chauffeur-driven hatchbacks, sedans, and executive cars for office staff transport, business travel, and airport transfers. Pune Corporate Cars India Private Limited provides managed corporate fleets for safe and comfortable commuting.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "5200", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // starting price per day, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-car-rentals-services-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Car Rentals Services in Pune | Chauffeur & Executive Cars | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate car rental services in Pune offering chauffeur-driven hatchbacks, sedans, and executive cars for office staff transport, business travel, and airport transfers. Pune Corporate Cars India Private Limited ensures safe and comfortable corporate commuting."
  />

  <meta
    name="keywords"
    content="Corporate Car Booking Pune, Pune Business Car Hire, Staff Car Rental Service Pune, Chauffeur Car Services Pune, Corporate Hatchback Rental Pune, Corporate Sedan Hire Pune, Executive Car Rentals Pune, Pune Corporate Fleet Solutions, Best Corporate Car Services Pune, Affordable Car Rentals Pune, Corporate Outstation Car Hire Pune, Office Pickup Drop Car Hire Pune, Company Car Rental Provider Pune, Employee Transportation Cars Pune, Pune Airport Car Rental Corporate"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecarrentalsserviceinpune;